import { Carousels } from './SlickCarousel'
import settings from "@/scripts/common/settings"

export class CardCarousel extends Carousels.SlickCarousel {
    constructor(container, options) {
        super(container, options)
        this.carouselType = this.$slider.dataset.carouselType || ''
        this.updateOptions({
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            lazyLoad: this.$slider.dataset.lazyload || false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 460,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        })

        this.arrowModifiers = `card-carousel__arrow-btn`

        this.init()
    }


    initCallback() {

        switch (this.carouselType) {
            case 'multiple-3':
                this.offsetClassUpdater()
                this.updateOptions({
                    slidesToShow: 3,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                centerMode: true,
                                slidesToShow: 2,
                                infinite: true
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                centerMode: true,
                                slidesToShow: 1,
                                infinite: true
                            }
                        },
                        {
                            breakpoint: 375,
                            settings: {
                                centerMode: true,
                                slidesToShow: 1,
                                infinite: true,
                                centerPadding: '30px'
                            }
                        }
                    ]
                })
                break
            case 'multiple-2':
                this.updateOptions({
                    slidesToShow: 2
                })
                break
            case 'single':
                
                this.updateOptions({
                    slidesToShow: 1,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                })
                $(this.$slider).on("init", () => {
                    window.setTimeout(() => this.playSlideVideo(0), 3000) // Play video if auto play on first init or slide
                })
                break
            case 'variable':
                this.updateCardWidth()
                this.updateOptions({
                    slidesToShow: this.$slider.dataset.itemsToShow || 2,
                    variableWidth: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                variableWidth: false,
                                infinite: true,
                                centerMode: true
                            }
                        }, {
                            breakpoint: 375,
                            settings: {
                                slidesToShow: 1,
                                variableWidth: false,
                                centerMode: true,
                                infinite: true,
                                centerPadding: '30px'
                            }
                        }
                    ]
                })
                break
        }
    }

    offsetClassUpdater() {
        if(this.$slides.length <= 3) {
            if(this.$slider.closest('.card-carousel--off-centered')) this.$slider.closest('.card-carousel--off-centered').classList.remove('card-carousel--off-centered')
        }
    }

    resizeCallback() {
        if(this.carouselType === 'variable') this.updateCardWidth()
    }

    updateCardWidth() {
        let largeBlogArticleFigureHeight = 0
        this.$slides.forEach($slide => {
            this.responsiveWidths($slide)
            const $blogArticleFigure = $slide.querySelector('.blog-article__image')
            if(!$blogArticleFigure) return
            if(window.innerWidth < 768) {
                $blogArticleFigure.style.minHeight = 0
                return
            }
            $blogArticleFigure.style.minHeight = 0
            const figureHeight = $blogArticleFigure?.getBoundingClientRect().height
            if(figureHeight > largeBlogArticleFigureHeight) largeBlogArticleFigureHeight = figureHeight
        })

        if(largeBlogArticleFigureHeight)
            this.$slides.forEach($slide => $slide.querySelector('.blog-article__image').style.minHeight = `${largeBlogArticleFigureHeight}px`)
    }

    responsiveWidths($slide) {
        const viewPortWidth = this.$slider.getBoundingClientRect().width 
        const lgCardWidth =  viewPortWidth * (settings.carouselWidth.lg / 100)
        const xlCardWidth =  viewPortWidth * (settings.carouselWidth.xl / 100)
        const smCardWidth =  viewPortWidth * (settings.carouselWidth.sm / 100)

        if(window.innerWidth < 768) {
            $slide.style.flex = 1;
            $slide.style.maxWidth = '100%';
            return
        }

        if ($slide.classList.contains('card-carousel__item--l')) {
            $slide.style.flex = `0 0 ${lgCardWidth}px`
            $slide.style.width = `${lgCardWidth}px`
            $slide.style.maxWidth = `${lgCardWidth}px`
        } else if ($slide.classList.contains('card-carousel__item--s')) {
            $slide.style.flex = `0 0 ${smCardWidth}px`
            $slide.style.width = `${smCardWidth}px`
            $slide.style.maxWidth = `${smCardWidth}px`
        } else if ($slide.classList.contains('card-carousel__item--xl')) {
            $slide.style.flex = `0 0 ${xlCardWidth}px`
            $slide.style.width = `${xlCardWidth}px`
            $slide.style.maxWidth = `${xlCardWidth}px`
        } else {
            $slide.style.flex = `0 0 ${viewPortWidth}px`
            $slide.style.width = `${viewPortWidth}px`
            $slide.style.maxWidth = `${viewPortWidth}px`
        }
    }
}

export default CardCarousel